<template>
  <div class="w-100 p-y-2 m-b-6">
    <div class="container d-flex flex-center text-center fd-column">
      <img :src="image" alt="Need a hand?">
      <div class="text-center">
        <h3 class="h3">{{content.title}}</h3>
        <p class=" m-b-5">
          {{content.description}}
        </p>
        <div>
          <button
              class="btn-lg btn BUTTON"
              @click="goToSalesforce()">
            {{content.cta}}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'become-a-pro',
  components: {
  },
  computed: {
    ...mapGetters('homepage/contentful', [
      'customerHomePage',
    ]),
    content () {
      return this.customerHomePage.closingSection;
    },
    image () {
      return this.customerHomePage.closingSection.image.fields.file.url;
    },
  },

  methods: {
    goToSalesforce () {
      this.$events.$emit(this.$events.PRO_SIGNUP, {
        occupation: 'None Selected',
      });
      window.location.href = `${this.content.ctaUrl}`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@homeservices/design-kit/tools.scss";
.BUTTON{
  width: $unit * 27.5;
}
</style>
